class ProductCardSwiperManager {
  constructor() {
    this.observer = null;
    this.init();
  }

  init() {
    if (typeof IntersectionObserver === 'undefined') {
      this.initAllSwipers();
      return;
    }

    this.observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            this.initSwiper(entry.target);
            this.observer.unobserve(entry.target);
          }
        }
      },
      {
        rootMargin: '10%',
        threshold: 0.01
      }
    );

    this.observeSwipers();
    this.setupDynamicObserver();
  }

  observeSwipers() {
    const swipers = document.querySelectorAll('swiper-container.product-card__swiper:not([data-initialized])');
    
    for (const swiper of swipers) {
      this.observer.observe(swiper);
    }
  }

  setupDynamicObserver() {
    const mutationObserver = new MutationObserver(() => {
      this.observeSwipers();
    });

    mutationObserver.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  initSwiper(swiperContainer) {
    const slidesCount = swiperContainer.querySelectorAll('swiper-slide').length;
    const prevBtn = swiperContainer.querySelector('.swiper-button-prev');
    const nextBtn = swiperContainer.querySelector('.swiper-button-next');
    const pagination = swiperContainer.querySelector('.swiper-pagination');

    const swiperParams = {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: false,
      on: {
        init: () => {
          swiperContainer.setAttribute('data-initialized', 'true');
        }
      }
    };

    // Only add navigation and pagination if there's more than one slide
    if (slidesCount > 1) {
      if (prevBtn && nextBtn) {
        swiperParams.navigation = {
          prevEl: prevBtn,
          nextEl: nextBtn,
        };
      }

      if (pagination) {
        swiperParams.pagination = {
          el: pagination,
          clickable: true,
        };
      }
    }

    Object.assign(swiperContainer, swiperParams);

    // Always initialize to ensure shadow DOM content is rendered
    swiperContainer.initialize();
  }

  initAllSwipers() {
    const swipers = document.querySelectorAll('swiper-container.product-card__swiper:not([data-initialized])');
    
    for (const swiper of swipers) {
      this.initSwiper(swiper);
    }
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new ProductCardSwiperManager();
  });
} else {
  new ProductCardSwiperManager();
}

